import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'

import ItemsSubitems from './ItemsSubitems'

class SubItems extends Component {
  constructor (props) {
    super(props)

    this.state = {
      subItemsSelected: false,
      selectedItem: []
    }
  }

  MaxLength = value => (value.length > 30 ? value.substring(0, 29) : value)

  closeMenu = () => {
    var checkMenu = document.getElementById('menuToggle')
    this.props.displayMenu[this.props.index].display = false

    if (checkMenu && checkMenu.checked === true) {
      checkMenu.checked = false
    }
    this.props.callReset()
  }

  handleSubmenu = (item) => {
    this.setState({ subItemsSelected: true, selectedItem: item })
  }

  handleBackButtonItemsSubitems = () => {
    this.setState({ subItemsSelected: false, selectedItem: [] })
  }

  render () {
    const { subItemsSelected, selectedItem } = this.state

    return (
      subItemsSelected
        ? (<ItemsSubitems selectedItem={selectedItem} closeMenu={this.closeMenu} handleBackButtonItemsSubitems={this.handleBackButtonItemsSubitems} />)
        : (
          this.props.displayMenu[this.props.index].display && (
            <div
              className={`subMenuToggle ${
                this.props.displayMenu[this.props.index].display ? 'active' : 'd-none'
              }`}
            >
              <ul className='txt-left radius px-0 py-0' tabIndex={-1}>
                <li className='px-2 py-0 border-color-ui-3 border-bottom bg-brand-4 mb-1'>
                  <div className='row align-items-center h-100 pos-relative d-flex align-content-center'>
                    <a
                      href='#'
                      onClick={this.props.close(-1)}
                      className={`color-ui-white mn-item color-ui-white fechar-menu w-100 h-100 d-flex align-items-center py-2 px-1`}
                      tabIndex={0}
                    >
                      <i className='icon icon_left_app color-ui-white mr-1' aria-hidden='true' />
                      Voltar
                    </a>
                  </div>
                </li>
                {this.props.items.map(item => (
                  ((item.items && item.items.length === 0) || !item.items) ? (
                    <li className='px-0 py-0 mx-2 border-bottom border-ui-2 h-100 item-menu-mobile'>
                      <div className='row h-100 d-flex align-content-center'>
                        <div className='col-12 px-0' onClick={() => { this.closeMenu() }}>
                          <a href={item.path} aria-label={this.MaxLength(item.label)} className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'>
                            <div className='row align-items-center h-100 pos-relative'>
                              <div className='col ml-2 pt-half py-half py-half title-mobile-link' aria-hidden>{this.MaxLength(item.label)}</div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </li>
                  ) : (
                    <li className='px-0 py-0 mx-2 border-bottom border-ui-2 h-100 item-menu-mobile'>
                      <div className='row h-100 d-flex align-content-center'>
                        <div className='col-12 px-0'>
                          <button onClick={() => this.handleSubmenu(item)} aria-label={`${this.MaxLength(item.label)}`} className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'>
                            <div className='row align-items-center h-100 pos-relative'>
                              <div className='col ml-2 pt-half txt-capitalize title-mobile-link' aria-hidden>{this.MaxLength(item.label)}</div>
                              <div className='col-auto icon-mobile'>
                                <div className='row mx-0'>
                                  <div className='col-auto px-0 mx-auto'>
                                    <Icon
                                      iconName='icon_right'
                                      className='icon-sm'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </li>
                  )
                ))
                }
                <li
                  data-path={this.props.path}
                  className={`px-0 py-0 mx-2 border-bottom border-ui-2 h-100 item-menu-mobile ${
                    (!this.props.path || this.props.path) === '#' ? 'd-none' : ''
                  }`}
                >
                  <div className='row h-100 pos-relative my-1 py-1 border-top border-color-ui-3 d-flex align-content-center' onClick={() => this.closeMenu()}>
                    <Link
                      className='btn btn-flat btn-icon txt-font-body txt-initial txt-body title-mobile-link'
                      to={this.props.path}
                      aria-label='Ver todas'
                    >
                      <strong aria-hidden>Ver todas</strong>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          )
        )
    )
  }
}

SubItems.propTypes = {
  items: PropTypes.array.isRequired,
  displayMenu: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  path: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  callReset: PropTypes.func.isRequired
}

SubItems.defaultProps = {
  path: '#'
}
export default SubItems



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/SubItems/SubItems.js